
export default function revalidate(env_key, overwrite = null) {
  if(!process.env[env_key])  {
    return 1;
  }

  const env = overwrite === null ? process.env[env_key] : overwrite;

  return { revalidate: parseInt(env) || 1 };
}
